import clsx from 'clsx';
import BrandLogo from './BrandLogo';

/**
 * Compact lockup for public pages sitting on a light surface. The dark tile is
 * not decoration: the mark's artwork is white and would vanish without it.
 */
export default function BrandBadge({ className }) {
  return (
    <div
      className={clsx(
        'inline-flex items-center gap-2.5 sm:gap-3 px-3.5 sm:px-4 py-2.5 sm:py-3 rounded-2xl bg-white border border-slate-200 shadow-sm',
        className
      )}
    >
      <div className="h-9 w-9 sm:h-10 sm:w-10 rounded-xl bg-slate-900 flex items-center justify-center">
        <BrandLogo showWordmark={false} size={20} className="sm:w-6" />
      </div>
      <div className="text-left">
        <p className="text-sm font-semibold text-slate-900 leading-tight">Genesis Creations</p>
        <p className="text-xs text-slate-500">Talent Hub</p>
      </div>
    </div>
  );
}
